// extracted by mini-css-extract-plugin
export default {"main":"LandingScreen_main__2Du5u","wrap":"LandingScreen_wrap__sOpE8","textWrap":"LandingScreen_textWrap__oEG6u","buttonExtra":"LandingScreen_buttonExtra__rpuXL"};